/**
 * Created by mykurisu on 2017/6/12.
 */
import React,{Component} from 'react'
import {connect} from 'react-redux'
import axios from 'axios';
import {Dialog} from 'react-weui';

import '../../styles/lecture/LectureClassPush.css';
import '../../styles/lecture/LectureForm.css';

class LectureLecturersInput extends Component{

    constructor (props){
        super(props);
        this.state ={
            lectureName: this.props.lecturers[this.props.lectureIndex].title,
            lectureIntro: this.props.lecturers[this.props.lectureIndex].introduction,
            lectureInputStyle: {
                title: '编辑嘉宾' + this.props.lecturers[this.props.lectureIndex].account.nickname + '的信息',
                buttons: [
                    {
                        type: 'default',
                        label: '取消',
                        onClick: this.handleLecturerClose.bind(this)
                    },
                    {
                        type: 'primary',
                        label: '确定',
                        onClick: this.handleLectureSubmit.bind(this)
                    }
                ]
            },
            lecturers: this.props.lecturers
        };
        this.handleLecturerClose = this.handleLecturerClose.bind(this);
        this.handleLectureNameValue = this.handleLectureNameValue.bind(this);
        this.handleLectureIntroValue = this.handleLectureIntroValue.bind(this);
        this.handleLectureSubmit = this.handleLectureSubmit.bind(this);
    }

    handleLecturerClose (){
        this.props.dispatch({
            type: 'LECTURE_HIDE_LECTURER_DIALOG'
        });
        this.setState({
            lectureName: '',
            lectureIntro: ''
        })
    }

    handleLectureNameValue (event){
        this.setState({
            lectureName: event.target.value
        })
    }

    handleLectureIntroValue (event){
        this.setState({
            lectureIntro: event.target.value
        })
    }

    handleLectureSubmit (){
        const {lectureId} = this.props;
        const {id} = this.props.lecturers[this.props.lectureIndex].account;
        let param = new FormData();
        param.append('account',id);
        param.append('title',this.state.lectureName);
        param.append('introduction',this.state.lectureIntro);
        axios.post(`/api/lecture/${lectureId}/lecturer/${id}/update`,param).then(res => {
            if (res.data.code === 0){
                let list = this.state.lecturers;
                list[this.props.lectureIndex].title = this.state.lectureName;
                list[this.props.lectureIndex].introduction = this.state.lectureIntro;
                this.setState({
                    lecturers: list
                });
                this.props.dispatch({
                    type: 'LECTURE_HIDE_LECTURER_DIALOG',
                    payload: this.state.lecturers
                });
            }
        });
    }

    render (){
        return(
            <div className="lecture-classpush-dialog__container lecture-from__container ">
                <div className="lecture-from-area_textarea">
                    <Dialog title={this.state.lectureInputStyle.title} buttons={this.state.lectureInputStyle.buttons}
                            show={true}>
                        <input type="text" placeholder="讲师/嘉宾/主持人" value={this.state.lectureName} onChange={this.handleLectureNameValue} maxLength="5"/>
                        <textarea placeholder="讲师介绍" value={this.state.lectureIntro} onChange={this.handleLectureIntroValue}>
                            </textarea>
                    </Dialog>
                </div>
            </div>
        )
    }
}

export default connect((state) => ({
    lectureIndex: state.lecture.lectureIndex,
    lecturers: state.lecture.lecturers
}))(LectureLecturersInput)


// WEBPACK FOOTER //
// ./src/components/lecture/LectureLecturersInput.js